import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ComponentForm from '../../../components/forms/ComponentForm';
import { useCreateComponent } from '../../../hooks/useComponentApi';
import { useNavigate } from 'react-router-dom';
import { ComponentDTO } from '../../../services/apiClient';

const ComponentCreate: React.FC = () => {
  const createMutation = useCreateComponent();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Components', href: '/admin/components' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: ComponentDTO) => {
    try {
      setIsSubmitting(true);
      await createMutation.mutateAsync(data);
      navigate('/admin/components');
    } catch (error) {
      console.error('Error creating Component:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/components"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.Component.Edit"
    >
      <ComponentForm
        initialValues={{} as ComponentDTO}
        onSubmit={handleSubmit}
        onCancel={() => navigate('/admin/components')}
        isLoading={isSubmitting}
      />
    </AdminLayout>
  );
};

export default ComponentCreate;
